module.exports = __webpack_public_path__ + "img/invite.7160b43c.png";